var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Observer',{on:{"intersecting":function($event){_vm.isVisible = true}}},[_c('div',{staticClass:"slide-fade",class:[_vm.direction, {visible: _vm.isVisible}]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }